import React from 'react';
import ConvertNumber from '../components/ConvertNumber';

const SingleInstallment = ({
    countNumber,
    paymentDate,
    paymentPositionPrice,
    paymentPositionPriceDiscount,
    periodFromDate,
    periodToDate,
    discountProcent,
    discountCash,
    setSelection,
    chckd,
    index,
    manth,
    selectedPromotions,
}) => {
    function parse(numberMonth) {
        let date = (numberMonth[5] > 0 ? numberMonth[5] : '') + numberMonth[6];
        let respons = manth.find((e) => e.valueID === +date);
        return respons.name;
    }

    return (
        (selectedPromotions.length > 0) ?
        <tr>
            <td id="installment-number-01" className="installment-number">
                {countNumber}
            </td>
            <td id="installment-sum-01" className="installment-sum">
                {ConvertNumber(paymentPositionPrice)} zł
            </td>
            <td id="installment-percentage-rebate-01" className="installment-percentage-rebate">
                - {ConvertNumber(discountProcent)}%
            </td>
            <td id="installment-sum-rebate-01" className="installment-sum-rebate">
                - {ConvertNumber(discountCash)} zł
            </td>
            <td id="installment-total-01" className="installment-total">
                {ConvertNumber(paymentPositionPriceDiscount)} zł
            </td>
            <td id="installment-month-01" className="installment-month">
                {parse(periodFromDate)}
            </td>
            <td id="installment-deadline-01" className="installment-deadline">
                {index === 0 ? new Date() : paymentDate}
            </td>
            <td id="installment-select-01" className="installment-select">
                <input
                    className="form__checkbox"
                    onClick={() => {
                        setSelection(paymentPositionPriceDiscount, countNumber);
                        localStorage.setItem('paymentPositionPrice', paymentPositionPriceDiscount);
                        localStorage.setItem('paymentPositionPrice', paymentPositionPrice);
                    }}
                    type="checkbox"
                    name=""
                    id=""
                    checked={chckd}
                    disabled={countNumber === index}
                />
            </td>
        </tr> : <tr>
            <td id="installment-number-01" className="installment-number">
                {countNumber}
            </td>
            <td id="installment-sum-01" className="installment-sum">
                {ConvertNumber(paymentPositionPrice)} zł
            </td>
            <td id="installment-month-01" className="installment-month">
                {parse(periodFromDate)}
            </td>
            <td id="installment-deadline-01" className="installment-deadline">
                {index === 0 ? new Date() : paymentDate}
            </td>
            <td id="installment-select-01" className="installment-select">
                <input
                    className="form__checkbox"
                    onClick={() => {
                        setSelection(paymentPositionPriceDiscount, countNumber);
                        localStorage.setItem('paymentPositionPrice', paymentPositionPriceDiscount);
                        localStorage.setItem('paymentPositionPrice', paymentPositionPrice);
                    }}
                    type="checkbox"
                    name=""
                    id=""
                    checked={chckd}
                    disabled={countNumber === index}
                />
            </td>
        </tr> 
    );
};
export default SingleInstallment;
